import request from '@/router/axios';

export function taskList(obj) {
  return request({
    url: '/dotadmin/dotRisk/taskList',
    method: 'post',
    data: obj,
  });
}

export function riskInfoByFlowId(obj) {
  return request({
    url: '/dotadmin/dotRisk/riskInfoByFlowId',
    method: 'post',
    data: obj,
  });
}

export function taskNumList(obj) {
  return request({
    url: '/dotadmin/dotRisk/taskNumList',
    method: 'post',
    data: obj,
  });
}

export function logList(obj) {
  return request({
    url: '/dotadmin/dotRisk/logList',
    method: 'post',
    data: obj,
  });
}

export function taskInfoByFlowId(obj) {
  return request({
    url: '/dotadmin/dotRisk/taskInfoByFlowId',
    method: 'post',
    data: obj,
  });
}

export function topFlow(obj) {
  return request({
    url: '/dotadmin/dotRisk/topFlow',
    method: 'post',
    data: obj,
  });
}

export function bottomFlow(obj) {
  return request({
    url: '/dotadmin/dotRisk/bottomFlow',
    method: 'post',
    data: obj,
  });
}

export function cancelSort(obj) {
  return request({
    url: '/dotadmin/dotRisk/cancelSort',
    method: 'post',
    data: obj,
  });
}

export function addLog(obj) {
  return request({
    url: '/dotadmin/dotRisk/addLog',
    method: 'post',
    data: obj,
  });
}

export function listByRoleCode(query) {
  return request({
    url: '/dotadmin/dotadmin/user/listByRoleCode',
    method: 'get',
    params: query,
  });
}

export function projectStausEmun() {
  return request({
    url: '/dotadmin/dotRisk/projectStausEmun',
    method: 'get',
  });
}

export function languageEmun() {
  return request({
    url: '/dotadmin/dotRisk/languageEmun',
    method: 'get',
  });
}

export function capacityStatistics() {
  return request({
    url: '/dotadmin/dotRisk/capacityStatistics',
    method: 'get',
  });
}

export function taskTypeEmun() {
  return request({
    url: '/dotadmin/dotRisk/taskTypeEmun',
    method: 'get',
  });
}

export function updateRisk() {
  return request({
    url: '/dotadmin/dotRisk/updateRisk',
    method: 'post',
  });
}

export function queryPushTrNum(query) {
  return request({
    url: '/dotadmin/dotRisk/queryPushTrNum',
    method: 'get',
    params: query,
  });
}

export function addTaskReserveTr(obj) {
  return request({
    url: '/dotadmin/dotRisk/addTaskReserveTr',
    method: 'post',
    data: obj,
  });
}

export function addTaskMaxAmount(obj) {
  return request({
    url: '/dotadmin/dotRisk/addTaskMaxAmount',
    method: 'post',
    data: obj,
  });
}

export function hideFlow(obj) {
  return request({
    url: '/dotadmin/dotRisk/hideFlow',
    method: 'post',
    data: obj,
  });
}

export function cancelHideFlow(obj) {
  return request({
    url: '/dotadmin/dotRisk/cancelHideFlow',
    method: 'post',
    data: obj,
  });
}

export function hideFlowList(obj) {
  return request({
    url: '/dotadmin/dotRisk/hideFlowList',
    method: 'post',
    data: obj,
  });
}

export function getScore(obj) {
  return request({
    url: '/dotadmin/dotRisk/getScore',
    method: 'post',
    data: obj,
  });
}

export function getScoureStatus(obj) {
  return request({
    url: '/dotadmin/dotRisk/getScoureStatus',
    method: 'post',
    data: obj,
  });
}

export function updateScore(obj) {
  return request({
    url: '/dotadmin/dotRisk/updateScore',
    method: 'post',
    data: obj,
  });
}

export function orderPeConfig(obj) {
  return request({
    url: '/dotadmin/dotRisk/orderPeConfig',
    method: 'post',
    data: obj,
  });
}

export function proceedQcMap() {
  return request({
    url: '/dotadmin/dotRisk/proceedQcMap',
    method: 'get',
  });
}
